import * as React from "react";
import {ReactUtilities} from "shared/utilities/react/ReactUtilities";
import {CSSProperties} from "react";
export enum WPTableSortDirectionEnum{
    none='none',
    asc='asc',
    desc='desc'
}

export class WPTH extends React.Component<WordpressTableProps, WordpressTableState> {
    static defaultProps: Partial<WordpressTableProps> = {
        IsSortable:false,
        SortDirection:WPTableSortDirectionEnum.none
    };

    constructor(props: WordpressTableProps) {
        super(props);
        this.state = {
            SortDirection:'none'
        };
    }

    public render() {
        if(this.props.IsSortable)
            return this.CreateSortableColumn();
        return this.CreateNormalColumn();

    }

    private CreateSortableColumn() {
        let sortDirectionClass;
        switch (this.props.SortDirection) {
            case WPTableSortDirectionEnum.none:
                sortDirectionClass='sortable asc';
                break;
            case WPTableSortDirectionEnum.desc:
                sortDirectionClass='sorted asc';
                break;
            case WPTableSortDirectionEnum.asc:
                sortDirectionClass='sorted desc';
                break;
        }
        return (
            <th className={sortDirectionClass} style={this.props.Styles}>
                <a style={{boxShadow:'none'}} href={'#'} onClick={e=>{e.preventDefault();this.SortingChanged()}}>
                    <span>{this.props.children}</span>
                    <span className={'sorting-indicator'}/>
                </a>
            </th>
        )
    }

    private CreateNormalColumn() {
        return (
            <th style={this.props.Styles}>
                {this.props.children}
            </th>
        )
    }

    private SortingChanged() {
        let newDirection;
        if(this.props.SortDirection==WPTableSortDirectionEnum.desc)
            newDirection=WPTableSortDirectionEnum.asc;
        else
            newDirection=WPTableSortDirectionEnum.desc;
        ReactUtilities.ExecuteMethodPropIfDefined(this.props.SortingChanged,newDirection);
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface WordpressTableProps {
    IsSortable?:boolean;
    SortDirection?:WPTableSortDirectionEnum
    SortingChanged?:(direction:WPTableSortDirectionEnum)=>void;
    Styles:CSSProperties;
}

interface WordpressTableState {

}




//#endregion "My Region"